import axios from "../axiosPlugin.js";

const basicUrl = "/api/invoice/";

export const getAccountReceivableList = data => {
  return axios({
    url: basicUrl + "list?" + data,
    method: "get",
    data: {},
  });
};

export const deleteAccountReceivable = data => {
  return axios({
    url: basicUrl + "delete/" + data.id,
    method: "get",
    data: {},
  });
};

export const readInvoiceRecord = data => {
  return axios({
    url: `${basicUrl}detail/${data.id}`,
    method: "get",
    data: {
      data
    },
  });
};

export const cancelAccountReceivable = data => {
  return axios({
    url: basicUrl + "cancel/" + data.id,
    method: "get",
    data: {},
  });
};

export const getCinemaList = () => {
  return axios({
    url: "/api/cinema/list?page=0&pageSize=9999",
    method: "get",
    data: {},
  });
};

export const createAccountReceivableList = data => {
  return axios({
    url: basicUrl + "create",
    method: "post",
    data: {
      data,
    }
  });
};

export const getBankAccountList = () => {
  return axios({
    url: "/api/bankAccount/list?page=0&pageSize=9999",
    method: "get",
    data: {},
  });
};

export const getBankAccountDetailService = id => {
  return axios({
    url: `/api/bankAccount/detail/${id}`,
    method: "get",
    data: {},
  });
};

export const getExtraction = data => {
  return axios({
    url: basicUrl + "extraction?" + data,
    method: "get",
    data: {},
  });
};

export const exportCSV = data => {
  return axios({
    url: "/api/invoice/export?" + data,
    method: "get",
    data: {
      data: {
        isDownladFile: true,
      }
    },
  });
};

export const getAccountReceivableTableCount = data => {
  return axios({
    url: basicUrl + "count?brandId=" + data.brandId,
    method: "get",
    data: {},
  });
};

export const getOtherGoodList = cinemaId => {
  return axios({
    url: "/api/otherGoods/list?page=0&pageSize=9999&cinemaId=" + cinemaId,
    method: "get",
    data: {},
  });
};

export const getAccountPayableList = brandId => {
  return axios({
    url: "/api/accountPayable/list?page=0&pageSize=9999&brandId=" + brandId,
    method: "get",
    data: {},
  });
};

export const getAccountPayableListMap = data => {
  return axios({
    url: "/api/accountPayable/listMap",
    method: "get",
    data: {
      data
    },
  });
};

export const getAccountPayableDetail = data => {
  return axios({
    url: `/api/accountPayable/detail/${data.id}`,
    method: "get",
    data: {}
  });
};

export const getOtherRevenueList = cinemaId => {
  return axios({
    url: "/api/otherRevenue/list?page=0&pageSize=9999&cinemaId=" + cinemaId,
    method: "get",
    data: {},
  });
};

export const approve = brandId => {
  return axios({
    url: basicUrl + "updateApprove?brandId=" + brandId,
    method: "post",
    data: {},
  });
};

export const getPDFInfo = id => {
  return axios({
    url: basicUrl + "pdfInfo/" + id,
    method: "get",
    data: {},
  });
};

export const updateAccountReceivable = data => {
  return axios({
    url: basicUrl + "update",
    method: "post",
    data: {
      data,
    }
  });
};

export const getInvoiceRevenueList = (brandId, invoiceId) => {
  return axios({
    url: "/api/invoiceRevenue/list?page=0&pageSize=9999&brandId=" + brandId + "&invoiceId=" + invoiceId,
    method: "get",
    data: {},
  });
};

export const createInvoiceRevenue = arr => {
  return axios({
    url: "/api/invoiceRevenue/create",
    method: "post",
    data: {
      data: arr,
    }
  });
};

export const updateInvoiceRevenue = obj => {
  return axios({
    url: "/api/invoiceRevenue/update",
    method: "post",
    data: {
      data: obj,
    }
  });
};

export const deleteInvoiceRevenue = id => {
  return axios({
    url: "/api/invoiceRevenue/delete/" + id,
    method: "get",
    data: {}
  });
};
